export const environment = {
    PRODUCT_MODE: true,
    API_URL: 'https://ec-assign-apis.weset.edu.vn',
};
